// src/context/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

export const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

const ACCOUNT_KEY = 'selectedAccount';

export const AppContextProvider = ({ children }) => {
  const [fullMenu, setFullMenu] = useState(false);
  const [isProcessRunning, setIsProcessRunning] = useState(false);

  // selected account — persisted in sessionStorage
  const [selectedAccount, setSelectedAccountState] = useState(() => {
    try {
      const stored = sessionStorage.getItem(ACCOUNT_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const setSelectedAccount = (account) => {
    if (account) {
      sessionStorage.setItem(ACCOUNT_KEY, JSON.stringify(account));
    } else {
      sessionStorage.removeItem(ACCOUNT_KEY);
    }
    setSelectedAccountState(account);
  };

  // impersonation — persisted in sessionStorage so it survives page reloads
  const [impersonating, setImpersonating] = useState(
    () => sessionStorage.getItem('impersonating') || null
  );

  const startImpersonation = (targetUsername, impersonationToken) => {
    sessionStorage.setItem('original_token', sessionStorage.getItem('token'));
    sessionStorage.setItem('token', impersonationToken);
    sessionStorage.setItem('impersonating', targetUsername);
    sessionStorage.removeItem(ACCOUNT_KEY);
    setImpersonating(targetUsername);
    setSelectedAccountState(null);
    window.location.reload();
  };

  const endImpersonation = () => {
    const original = sessionStorage.getItem('original_token');
    if (original) {
      sessionStorage.setItem('token', original);
      sessionStorage.removeItem('original_token');
    }
    sessionStorage.removeItem('impersonating');
    sessionStorage.removeItem(ACCOUNT_KEY);
    setImpersonating(null);
    setSelectedAccountState(null);
    window.location.reload();
  };

  const toggHeader = () => setFullMenu((v) => !v);

  return (
    <AppContext.Provider value={{
      fullMenu, toggHeader,
      isProcessRunning, setIsProcessRunning,
      selectedAccount, setSelectedAccount,
      impersonating, startImpersonation, endImpersonation,
    }}>
      {children}
    </AppContext.Provider>
  );
};
